// extracted by mini-css-extract-plugin
export default {"questions":"QAndA_questions__--Cp8","see-more":"QAndA_see-more__nUTRX","new-question":"QAndA_new-question__5xVnX"};